// ---------- START IMPORT BLOCK ----------
import APIService from '../Core/APIService';
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import type {
  AuthorizedTranslatedUser,
  UserWhitelistResponse,
  UpdateUserWhitelistParams,
} from '../../Types/schema-helpers';
// ---------- END IMPORT BLOCK ----------

class WhitelistService extends APIService {
  /**
   * Fetches the current user's whitelist access list.
   */
  async fetchWhitelist(): Promise<UserWhitelistResponse> {
    return this.get<UserWhitelistResponse>(API_ROUTES.read_whitelist);
  }

  /**
   * Updates the user whitelist access list with string usernames.
   * Returns full UserWhitelistResponse with enriched names and usernames.
   */
  async updateWhitelist(usernames: string[]): Promise<UserWhitelistResponse> {
    const payload: UpdateUserWhitelistParams = { whitelist: usernames };
    return this.put<UserWhitelistResponse, UpdateUserWhitelistParams>(
      API_ROUTES.update_whitelist,
      payload
    );
  }

  /**
   * Searches for a user across the network by username.
   */
  async searchUserWhitelist(query: string): Promise<string | null> {
    return this.get<string | null>(API_ROUTES.search_user_whitelist(query));
  }
}

export default new WhitelistService();